import { onWxConfig } from '@/api';

var wx = require('weixin-js-sdk');

// iOS 微信在 SPA 内校验的是 WebView 首次进入时的 URL，而不是路由切换后的地址。
// 该值必须在 Vue Router 改写地址前记录，OAuth 回跳场景下也能保留真实签名地址。
const WECHAT_ENTRY_URL = window.location.href.split('#')[0];
const IS_IOS_WECHAT = /micromessenger/i.test(navigator.userAgent)
    && /(iphone|ipad|ipod)/i.test(navigator.userAgent);

let wxReadyKey = '';
let wxReadyPromise = null;

function getSignUrl(url) {
    return IS_IOS_WECHAT ? WECHAT_ENTRY_URL : (url || window.location.href).split('#')[0];
}

function waitForWxReady(wxConfigParam, weixinParam) {
    return new Promise(resolve => {
        let completed = false;
        const finish = success => {
            if (completed) return;
            completed = true;
            clearTimeout(timer);
            resolve(success);
        };
        const timer = setTimeout(() => finish(false), 10000);

        wx.ready(() => finish(true));
        wx.error(res => {
            console.log('wx.config error', res);
            if (weixinParam.type == 1 && weixinParam.retryCount <= 1) {
                location.reload();
            }
            finish(false);
        });
        wx.config({
            debug: false,
            appId: wxConfigParam.appId,
            timestamp: wxConfigParam.timestamp,
            nonceStr: wxConfigParam.nonceStr,
            signature: wxConfigParam.signature,
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'chooseWXPay',
                'scanQRCode'
            ],
        });
    });
}

function updateShareData(weixinParam) {
    const shareData = {
        title: weixinParam.title,
        desc: weixinParam.desc,
        link: weixinParam.shareUrl || weixinParam.url,
        imgUrl: weixinParam.imgUrl,
    };

    return new Promise(resolve => {
        let completed = false;
        const finish = success => {
            if (completed) return;
            completed = true;
            clearTimeout(timer);
            resolve(success);
        };
        const timer = setTimeout(() => finish(false), 5000);

        // “发送给朋友”的配置完成后才允许业务层展示可分享弹窗。
        wx.updateAppMessageShareData({
            ...shareData,
            success: () => finish(true),
            fail: res => {
                console.log('updateAppMessageShareData error', res);
                finish(false);
            },
        });
        wx.updateTimelineShareData({
            title: shareData.title,
            link: shareData.link,
            imgUrl: shareData.imgUrl,
            fail: res => console.log('updateTimelineShareData error', res),
        });
    });
}

function ensureWxReady(publicType, signUrl, weixinParam) {
    const readyKey = `${publicType}|${signUrl}`;
    if (wxReadyPromise && wxReadyKey === readyKey) {
        return wxReadyPromise;
    }

    wxReadyKey = readyKey;
    const currentPromise = onWxConfig({
        publicType,
        urlString: signUrl,
    }).then(response => {
        if (response.code !== 200) return false;
        return waitForWxReady(response.data, weixinParam);
    }).catch(err => {
        console.log('wx config request error', err);
        return false;
    });

    let readyPromise;
    readyPromise = currentPromise.then(success => {
        if (!success && wxReadyPromise === readyPromise) {
            wxReadyPromise = null;
            wxReadyKey = '';
        }
        return success;
    });
    wxReadyPromise = readyPromise;
    return wxReadyPromise;
}

/**
 * 初始化微信 JS-SDK 并等待分享信息真正注册完成。
 * @return {Promise<boolean>} true 表示“发送给朋友”的分享数据已经设置成功。
 */
export async function weixinInit(weixinParam) {
    try {
        const publicType = weixinParam.publicType || localStorage.getItem('publicType') || 1;
        const signUrl = getSignUrl(weixinParam.url);
        const ready = await ensureWxReady(publicType, signUrl, weixinParam);
        if (!ready) return false;
        return await updateShareData(weixinParam);
    } catch (err) {
        console.log('weixinInit error', err);
        return false;
    }
}

// 保留原导出，兼容可能存在的外部调用。
export async function doWxConfigInit(wxConfigParam, weixinParam) {
    const ready = await waitForWxReady(wxConfigParam, weixinParam);
    if (!ready) return false;
    return updateShareData(weixinParam);
}
